import { FieldNameEnum } from '@mark43/cad-api';
import { useBootstrapState } from '../../bootstrap/bootstrap-provider';

export function useSubPremiseFieldLabels() {
    const { fieldDisplayNameByFieldName } = useBootstrapState();

    return {
        subPremiseNameLabel:
            fieldDisplayNameByFieldName[FieldNameEnum.DISPLAY_ONLY_SUB_PREMISE_NAME_LABEL.name] ||
            'Sub-premise Name',
        subPremiseValueLabel:
            fieldDisplayNameByFieldName[FieldNameEnum.DISPLAY_ONLY_SUB_PREMISE_VALUE_LABEL.name] ||
            'Sub-premise Value',
    };
}
